var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconPersonGray(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 9H40C43.866 9 47 12.134 47 16V40C47 43.866 43.866 47 40 47H9V9Z",
    fill: "#A0A4AB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28 27C31.3137 27 34 24.3137 34 21C34 17.6863 31.3137 15 28 15C24.6863 15 22 17.6863 22 21C22 24.3137 24.6863 27 28 27Z",
    fill: "#D6D9DE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.9172 40C37.9718 39.5877 38 39.1672 38 38.7404C38 33.3609 33.5228 29 28 29C22.4772 29 18 33.3609 18 38.7404C18 39.1672 18.0282 39.5877 18.0828 40H37.9172Z",
    fill: "#D6D9DE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPersonGray);
export default __webpack_public_path__ + "static/media/icon-person-gray.e2799fc386f2788ef20507aaf77edc6e.svg";
export { ForwardRef as ReactComponent };